import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import { withTranslation } from 'react-i18next';

import { setWizardStep } from './../../../actions/basket-actions';

import WizardSteps from '../wizard-steps';

class OrderFailed extends React.Component {

    componentDidMount() {
        dataLayer.push( {
            'event': 'VirtualPageview',
            'virtualPageURL': '/kosik/failed',
            'virtualPageTitle': 'Košík - order failed'
        } );
    }

    handleClickTryAgain = e => {
        const { props: { setWizardStep } } = this;
        e.preventDefault();

        setWizardStep( WizardSteps.CONTACT_INFO )
    }

    render() {
        const { props: { basket: { errorCode } }, handleClickTryAgain } = this;


        return (
                <div className="order-detail">
                
                    <h2>{ this.props.t( 'basket.wizard.orderFailed.headline' ) }</h2>    
                    <p className="lead">
                        { this.props.t( 'basket.wizard.orderFailed.message1' ) } <span style={{ color: 'red', fontWeight: 'bold' }}>{errorCode}</span>. 
                    </p>
                    <p className="lead">
                        { this.props.t( 'basket.wizard.orderFailed.message2' ) }
                    </p>
                
                    <a onClick={handleClickTryAgain} className="btn btn-lg btn-basket add">
                            { this.props.t( 'basket.wizard.orderFailed.tryAgain' ) }
                    </a>
                </div>
                );
    }

}

const mapStateToProps = (state) => ({
  basket: state.basket
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    setWizardStep
}, dispatch );

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()( OrderFailed ));
